import React, {memo, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {capitalize, contentUrlSolver, slugify} from '../../../helpers';
import {loadShows} from '../../../store/actions/show';
import {mobileMediaQuery} from '../../../styles';

const RecommendedSearch = () => {
    const shows = useSelector(state => state.show.shows);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        if (!shows) {
            dispatch(loadShows());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!shows) {
        return null;
    }

    return (
        <Container>
            <Title>{t('search.recommended')}</Title>
            <ItemContainer>
                {shows.slice(0, 5).map(show => (
                    <RecommendedItem show={show} />
                ))}
            </ItemContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 818px;
    align-items: center;
`;

const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    ${mobileMediaQuery} {
        flex-direction: column;
        flex-wrap: nowrap;
    }
`;

const RecommendedItem = ({show}) => {
    const images = useSelector(state => state.config.images);

    let url = contentUrlSolver({images}, show.image, 'SHOW-SELECTOR', 'png');

    return (
        <SearchContainer to={`/shows/${slugify(show.title)}`}>
            <CharImage src={url} />
            <Title>{capitalize(show.title, true)}</Title>
        </SearchContainer>
    );
};

const SearchContainer = styled(Link)`
    background-color: #494249;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    margin: 5px;
    align-items: center;
    color: transparent;
    align-self: baseline;
`;

const Title = styled.div`
    font-family: AvenirNextRoundedStd;
    font-size: 16px;
    font-weight: 700;
    color: white;
    padding: 11px;

    ${mobileMediaQuery} {
        font-size: 12px;
        padding: 8px;
    }
`;

const CharImage = styled.img`
    width: 40px;
    height: 40px;
    margin: 4px 0px 0px 10px;
    ${mobileMediaQuery} {
        width: 30px;
        height: 30px;
    }
`;

export default memo(RecommendedSearch);
